export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if (!this.importResult) {
            this.$state.go('^', {}, {location: 'replace'})
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/import/result/import-result.controller.js